module.exports = __webpack_public_path__ + "img/form_endcontroll.0d021b6d.svg";